import { FC, useRef, useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';

export const SlidingTitle: FC<{
  text: string;
  active: boolean;
  className: string;
  innerClassName: string;
}> = ({ text, active, className, innerClassName }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLSpanElement>(null);
  const [distance, setDistance] = useState(0);

  useEffect(() => {
    const inner = innerRef.current;
    const container = containerRef.current;
    if (!inner || !container) return undefined;

    const measure = () =>
      setDistance(Math.max(0, inner.scrollWidth - container.clientWidth));

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(inner);
    ro.observe(container);
    return () => ro.disconnect();
  }, []);

  return (
    <Typography
      variant="body2"
      component="div"
      ref={containerRef}
      className={className}
    >
      <span
        ref={innerRef}
        className={innerClassName}
        style={{
          transform:
            active && distance > 0
              ? `translateX(-${distance}px)`
              : 'translateX(0)',
          transitionDuration: `${Math.max(distance / 60, 0.3)}s`,
        }}
      >
        {text}
      </span>
    </Typography>
  );
};
